import { Component, Input } from '@angular/core';

/** @deprecated - this is moved to libs */
@Component({
    selector: 'ins-faq-item',
    templateUrl: './faq-item.component.html'
})
export class FaqItemComponent {
    @Input() public vraag;

    constructor() { }
}
